const questions = [
  {
    step: 1,
    image: '',
    content:
      '공부/일을 하려고 앉은 순간, 단톡방에 ㅋㅋㅋㅋ가 미친듯이 뜨기 시작했다.',
  },
  {
    step: 2,
    image: '',
    content: '회사원인 당신. 둘 중에 한 업무를 선택한다면?',
  },
  {
    step: 3,
    image: '',
    content: '자기계발에 대한 솔직한 입장은?',
  },
  {
    step: 4,
    image: '',
    content: '여행 중 들른 숙소에서 밀실 살인사건이 벌어졌다. 나는...',
  },
  {
    step: 5,
    image: '',
    content: '화성에 고립돼 2년 동안 감자만 먹게 된 나는...',
  },
  {
    step: 6,
    image: '',
    content: '팀 프로젝트에 참여하게 됐다. 어떤 역할을 맡고 싶은가?',
  },
  {
    step: 7,
    image: '',
    content: '방이 어질러져 있을 때 당신의 행동은?',
  },
  {
    step: 8,
    image: '',
    content: '휴가지에서 당신이 가장 선호하는 활동은?',
  },
  {
    step: 9,
    image: '',
    content: '어느날 두둑한 보너스가 들어왔다.',
  },
  {
    step: 10,
    image: '',
    content: '주로 스트레스를 푸는 방법은?',
  },
  {
    step: 11,
    image: '',
    content: '샤워를 하면서 당신이 주로 하는 행동은?',
  },
  {
    step: 12,
    image: '',
    content: '친구와의 약속이 갑자기 취소됐다. 당신의 반응은?',
  },
];

export default questions;
